function decimalPlaces(n, p) {
    return n.toFixed(p)
  }
  
export default decimalPlaces